@use '@lib/assets/styles/main.scss' as *;
@use "@lib/components/Input/_input-vars.scss" as *;

.tableWrap {
  margin: 0 -16px;
}

.tableWrapWhenEmpty {
  margin: 0;
}

.tableContainer {
  border-bottom: none;
  border-left: none;
  border-right: none;
  border-radius: unset;
}

.header {
  height: $inputMediumHeight;
  margin-bottom: 8px;
  & > div {
    width: 100%;
  }
}

.headerWithBackBtn {
  height: $inputMediumHeight;
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 56px;
  margin-bottom: 8px;
}

.headerBackBtn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
